var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-geo-json',{attrs:{"visible":_vm.mapRegionsWithGeoData && _vm.$store.state.mode === 'otachange',"geojson":_vm.mapRegionsWithGeoData,"options":_vm.mapRegionsOptionsOtaChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }